import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    borderRadius: '0.5rem',
    height: '100%',
    minHeight: '64vh',
  },

  itemList: {
    marginTop: '-1.5rem !important',
  },
}))

export { useStyles }
